<template>
  <v-card elevation="0" rounded="0" color="borderInner" style="width: 100%; height: 100%;">
    <div v-if="loader.selectCRMAgentStickerFromCRMAgentStickersComponent" style="width: 100%; height: 100%; display: flex; text-align: center; align-items: center; justify-content: center;">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else style="width: 100%; height: 100%;">
      <div v-if="display.CRMAgentSticker.length == 0" style="height: 100%; width: 100%; text-align: center; padding: 20px; cursor: default; user-select: none; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 200px;">
        <v-icon size="large" color="grey">mdi-information</v-icon>
        <div style="margin-top: 10px; color: grey;">
          <p>No hay stickers disponibles para este agente</p>
        </div>
      </div>
      <draggable v-model="display.CRMAgentSticker" @change="updateCRMAgentStickerIndex" item-key="CRMAgentStickerID" style="width: 100%; height: 100%; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none; display: grid; grid-template-columns: repeat(auto-fill, 100px); grid-auto-rows: 100px; justify-content: center;">
        <template #item="{ element }">
          <div style="width: 100px; height: 100px; display: flex; align-items: center; justify-content: center;">
            <v-menu v-model="navigation.CRMAgentStickerContextMenuIsVisible[element.CRMAgentStickerID]" :close-on-content-click="false" :scrim="true">
              <template #activator="{ props }">
                <img 
                  v-bind="{ ...props, onClick: undefined }" 
                  @contextmenu.prevent="navigation.CRMAgentStickerContextMenuIsVisible[element.CRMAgentStickerID] = true" 
                  :src="element.CRMAgentStickerMediaURL" 
                  draggable="false" 
                  class="hoverableElement" 
                  style="max-width: 100%; max-height: 100%; object-fit: contain;">
              </template>
              <v-list density="compact" style="padding: 0; margin: 0; user-select: none; overflow-x: hidden;">
                <v-list-item @click="$root.dialogComponent.openCRMAgentStickerDialog(false, true, false, element); navigation.CRMAgentStickerContextMenuIsVisible[element.CRMAgentStickerID] = false;" density="compact" class="hoverableText"><v-icon color="primary" style="margin-right: 10px; padding: 0;">mdi-pencil</v-icon>Actualizar sticker</v-list-item>
                <v-list-item @click="$root.dialogComponent.openCRMAgentStickerDialog(false, false, true, element); navigation.CRMAgentStickerContextMenuIsVisible[element.CRMAgentStickerID] = false;" density="compact" class="hoverableText"><v-icon color="primary" style="margin-right: 10px; padding: 0;">mdi-delete</v-icon>Eliminar sticker</v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </draggable>
    </div>
  </v-card>
</template>

<style scoped>
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import websocket from '@/utilities/websocket';
  import draggable from 'vuedraggable';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: 
    {
      draggable
    },
    data: () => ({
      display: 
      {
        CRMAgentSticker: []
      },
      navigation: 
      {
        CRMAgentStickerContextMenuIsVisible: {}
      },
      loader: 
      {
        selectCRMAgentStickerFromCRMAgentStickersComponent: false
      },
      websocketCallback:
      {
        updateCRMAgentSticker: null,
        deleteCRMAgentSticker: null
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    methods: {

      async selectCRMAgentStickerFromCRMAgentStickersComponent() {
        this.loader.selectCRMAgentStickerFromCRMAgentStickersComponent = true;
        const selectCRMAgentStickerFromCRMAgentStickersComponentRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          }
        };
        const selectCRMAgentStickerFromCRMAgentStickersComponentResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/CRMAgentSticker/functions/selectCRMAgentStickerFromCRMAgentStickersComponent', selectCRMAgentStickerFromCRMAgentStickersComponentRequestQuery);
        if (selectCRMAgentStickerFromCRMAgentStickersComponentResult.success){
          this.display.CRMAgentSticker = selectCRMAgentStickerFromCRMAgentStickersComponentResult.result;
          this.loader.selectCRMAgentStickerFromCRMAgentStickersComponent = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMAgentStickerFromCRMAgentStickersComponent_error', 'error', 'Ha ocurrido un error inesperado al consultar los stickers del agente, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        } 
      },

      async updateCRMAgentStickerIndex(updatedCRMAgentSticker) {
        const CRMAgentStickerID = updatedCRMAgentSticker.moved.element.CRMAgentStickerID;
        const CRMAgentStickerOldIndex = updatedCRMAgentSticker.moved.oldIndex + 1;
        const CRMAgentStickerNewIndex = updatedCRMAgentSticker.moved.newIndex + 1;
        if (CRMAgentStickerOldIndex != CRMAgentStickerNewIndex){
          const updateCRMAgentStickerIndexRequestQuery =
          {
            'localStorage': 
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
            },
            'CRMAgentStickerID': CRMAgentStickerID,
            'CRMAgentStickerOldIndex': CRMAgentStickerOldIndex,
            'CRMAgentStickerNewIndex': CRMAgentStickerNewIndex
          };
          const updateCRMAgentStickerIndexResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/CRMAgentSticker/functions/updateCRMAgentStickerIndex', updateCRMAgentStickerIndexRequestQuery);
          if (updateCRMAgentStickerIndexResult.success == false){
            updatedCRMAgentSticker.moved.element.CRMAgentStickerIndex = CRMAgentStickerOldIndex;
            this.display.CRMAgentSticker.sort((CRMAgentStickerA, CRMAgentStickerB) => CRMAgentStickerA.CRMAgentStickerIndex - CRMAgentStickerB.CRMAgentStickerIndex);
            this.$root.notificationDialog.showSystemNotificationDialog(updateCRMAgentStickerIndexResult.result, 'error', 'Ha ocurrido un error al reordenar el sticker, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
        }
      },

      connectWebsocket(){
        websocket.connectWebsocket();
        this.websocketCallback.updateCRMAgentSticker = async (websocketMessageData) => {
          const CRMAgentSticker = this.display.CRMAgentSticker.find(CRMAgentSticker => CRMAgentSticker.CRMAgentStickerID == websocketMessageData.websocketMessageContent.CRMAgentStickerID);
          if (CRMAgentSticker) CRMAgentSticker.CRMAgentStickerName = websocketMessageData.websocketMessageContent.CRMAgentStickerName;
        };
        this.websocketCallback.deleteCRMAgentSticker = async (websocketMessageData) => {
          const CRMAgentSticker = this.display.CRMAgentSticker.find(CRMAgentSticker => CRMAgentSticker.CRMAgentStickerID == websocketMessageData.websocketMessageContent.CRMAgentStickerID);
          if (CRMAgentSticker) {
            this.display.CRMAgentSticker = this.display.CRMAgentSticker.filter(CRMAgentSticker => CRMAgentSticker.CRMAgentStickerID != websocketMessageData.websocketMessageContent.CRMAgentStickerID);
            this.display.CRMAgentSticker.filter(CRMAgentSticker => CRMAgentSticker.CRMAgentStickerIndex > websocketMessageData.websocketMessageContent.CRMAgentStickerIndex).forEach(CRMAgentSticker => CRMAgentSticker.CRMAgentStickerIndex = CRMAgentSticker.CRMAgentStickerIndex - 1);
            this.display.CRMAgentSticker.sort((CRMAgentStickerA, CRMAgentStickerB) => CRMAgentStickerA.CRMAgentStickerIndex - CRMAgentStickerB.CRMAgentStickerIndex);
          }
        };
        if (this.websocketCallback.updateCRMAgentSticker) websocket.addWebsocketMessageListener('/CRMAgent/CRMAgentSticker/functions/updateCRMAgentSticker', this.websocketCallback.updateCRMAgentSticker);
        if (this.websocketCallback.deleteCRMAgentSticker) websocket.addWebsocketMessageListener('/CRMAgent/CRMAgentSticker/functions/deleteCRMAgentSticker', this.websocketCallback.deleteCRMAgentSticker);
      },

      disconnectWebsocket(){
        if (this.websocketCallback.updateCRMAgentSticker) websocket.removeWebsocketMessageListener('/CRMAgent/CRMAgentSticker/functions/updateCRMAgentSticker', this.websocketCallback.updateCRMAgentSticker);
        this.websocketCallback.updateCRMAgentSticker = null;
        if (this.websocketCallback.deleteCRMAgentSticker) websocket.removeWebsocketMessageListener('/CRMAgent/CRMAgentSticker/functions/deleteCRMAgentSticker', this.websocketCallback.deleteCRMAgentSticker);
        this.websocketCallback.deleteCRMAgentSticker = null;
      },

      async getSystemInformationData() {
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
    },

    async mounted() {
      await this.getSystemInformationData();
      this.selectCRMAgentStickerFromCRMAgentStickersComponent();
      this.connectWebsocket();
    },

    beforeUnmount() {
      this.disconnectWebsocket();
    }
  }
</script>
